// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2RiRk","signatureButtonsRight":"ModalSign_signatureButtonsRight__XWImw"};